<!-- Topbar icon -->
<div class="topbar-item" (click)="showGridModal()" title="Announcement" style="cursor: pointer;">
    <div [class]="customStyle + ' btn-dropdown d-flex align-items-center justify-content-center'">
        <i class="flaticon2-speaker icon-blue-blink" style="font-size: 1.4rem;"></i>
    </div>
</div>

<!-- Grid Modal -->
<ng-template #gridModal>
    <div class="modal-header"
        style="border-bottom: 1px solid #eee; padding: 16px 24px; display:flex; align-items:center; justify-content:space-between;">
        <h4 class="modal-title" style="font-weight: 700; font-size: 1.3rem; margin: 0;">Announcements</h4>
        <button type="button" (click)="closeGridModal()"
            style="font-size: 1.5rem; background: none; border: none; cursor: pointer; line-height:1; padding:0 4px;">
            &times;
        </button>
    </div>
    <div class="modal-body" style="padding: 16px 20px; max-height: 60vh; overflow-y: auto;"
         (scroll)="onGridScroll($event)">
        <ng-container *ngIf="activeAnnouncements.length === 0 && !isLoadingMore">
            <p style="text-align: center; color: #888; padding: 24px 0;">No announcements available.</p>
        </ng-container>
        <div class="announcement-grid" *ngIf="activeAnnouncements.length > 0">
            <div class="announcement-card"
                 [class.unread]="isUnread(a)"
                 *ngFor="let a of activeAnnouncements"
                 (click)="openLightbox(a)">
                <img [src]="a.imagePath" [alt]="a.title" />
                <div class="announcement-card-title">{{ a.title }}</div>
                <div *ngIf="isUnread(a)" class="new-badge">NEW</div>
            </div>
        </div>
        <div *ngIf="isLoadingMore" style="text-align: center; padding: 16px 0; color: #888;">
            <i class="fas fa-spinner fa-spin"></i> Loading...
        </div>
    </div>
    <div class="modal-footer"
        style="border-top: 1px solid #eee; padding: 12px 20px; justify-content: flex-start;">
        <span style="font-size: 0.85rem; color: #888;">
            {{ activeAnnouncements.length }} announcement(s)
            <ng-container *ngIf="hasMoreAnnouncements"> &mdash; scroll down to load more</ng-container>
        </span>
    </div>
</ng-template>

<!-- Lightbox Modal -->
<ng-template #lightboxModal>
    <div style="display:flex; flex-direction:column; max-height:calc(100vh - 56px);
                border-radius:12px; overflow:hidden; background:#000;">
        <div style="display:flex; align-items:flex-start; padding:10px 14px; gap:12px;
                    background:rgba(0,0,0,0.75); flex-shrink:0;">
            <span style="flex:1; font-size:0.88rem; font-weight:600; color:#fff;
                         word-break:break-word; white-space:normal;">
                {{ selectedAnnouncement?.title }}
            </span>
            <span style="flex:2; font-size:0.88rem; color:rgba(255,255,255,0.85); text-align:center;
                         word-break:break-word; white-space:normal;">
                {{ selectedAnnouncement?.description }}
            </span>
            <span (click)="closeLightboxAndReturnToGrid()"
                  style="flex:1; font-size:0.88rem; color:#fff; text-align:right;
                         cursor:pointer; text-decoration:underline;
                         white-space:nowrap; flex-shrink:0;">
                Back
            </span>
        </div>
        <div style="flex:1 1 auto; min-height:0; overflow:auto; line-height:0;
                    display:flex; align-items:center; justify-content:center;">
            <img [src]="selectedAnnouncement?.imagePath"
                 [alt]="selectedAnnouncement?.title"
                 style="max-width:100%; max-height:calc(100vh - 130px);
                        width:auto; height:auto; object-fit:contain; display:block;">
        </div>
    </div>
</ng-template>